export function getConditions(state) {
  return state.conditions;
}

export function getConditionsList(state) {
  return getConditions(state).list.toArray();
}
